const COLOR = {
  GREY_LIGHTEST: '#f7f8f8',
  GREY_LIGHTER: '#f2f3f3',
  GREY_LIGHT: '#0000001A',
  GREY_MEDIUM: '#bfc4c6',
  GREY_DARK: '#7f888c',
  GREY_DARKER: '#404e54',
  BLACK: '#00121a',
  WHITE: '#ffffff',
  BLUE_LIGHTER: '#d6ecf5',
  BLUE_LIGHT: '#bfe1ef',
  BLUE_MEDIUM: '#0088bf',
  BLUE_DARK: '#006e9b',
  TEAL_LIGHT: '#bfebeb',
  TEAL_MEDIUM: '#00aeb1',
  RED_LIGHT: '#fad4d8',
  RED_MEDIUM: '#ea5265',
  YELLOW_LIGHT: '#ffe594',
  YELLOW_MEDIUM: '#ffdd00',
  ORANGE: '#ffb800',
  PURPLE: '#f571f6',
}

export { COLOR }
